<template>
  <div class="change-password">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toAccountSetting">账号设置/</span>修改密码
      </template>
      <template v-slot:content>
        <div class="main">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="80px"
            class="demo-ruleForm"
          >
            <el-form-item label="登录账号:" prop="username">
              <el-input
                class="disabled"
                v-model="ruleForm.username"
                placeholder="显示已登录的账号"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="旧密码:" prop="oldPass">
              <el-input class="gray" type="password" v-model="ruleForm.oldPass"></el-input>
            </el-form-item>
            <el-form-item label="新密码:" prop="pass">
              <el-input class="gray" type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码:" prop="checkPass">
              <el-input
                class="gray"
                type="password"
                v-model="ruleForm.checkPass"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="resetForm('ruleForm')" class="btn-white">取消</el-button>
              <el-button type="primary" @click="submitForm('ruleForm')" class="btn-blue">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import DBUser from 'models/db/user.js';
const dbUser = new DBUser();
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        username: '',
        oldPass: '',
        pass: '',
        checkPass: ''
      },
      rules: {
        oldPass: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        pass: [{ required: true, validator: validatePass, trigger: 'blur' }],
        checkPass: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      }
    };
  },
  components: {
    SecondMenuLinkContent
  },
  created() {
    this.ruleForm.username = this.$route.query.username;
  },
  methods: {
    // 提交修改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let username = this.ruleForm.username;
          let password = this.ruleForm.oldPass;
          let newPassword = this.ruleForm.pass;
          let surePassword = this.ruleForm.checkPass;
          let data = {
            username,
            password
          };
          dbUser
            .postDBChangePassword(data, surePassword, newPassword)
            .then(res => {
              console.log(res);
              if (res.success) {
                this.$message.success('修改成功');
                this.$router.push('account-setting');
              } else {
                this.$message.error(res.message);
              }
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 清空修改
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$router.push('account-setting');
    },
    // 返回前一页
    toAccountSetting() {
      this.$router.push('account-setting');
    }
    // 获取当前用户登录信息
    // getInformation() {
    //   dbUser.getDBInformation().then(res => {
    //     if (res.success) {
    //       this.ruleForm.username = res.result.username;
    //     }
    //   });
    // }
  }
};
</script>

<style lang="scss">
.change-password {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .main {
    .el-form {
      padding: 20px 0 0 37px;
      letter-spacing: 1px;
      .el-form-item {
        margin-bottom: 20px;
        .el-form-item__content {
          width: 300px;
        }
        .el-button {
          width: 96px;
          letter-spacing: 4px;
        }
      }
    }
  }
}
</style>
